import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { HEC_CONSTANTS } from '../../../app/utilities/constants';
import { ConfirmationModalService } from '../shared-components/confirmation-modal/confirmation-modal.service';
import { MatSnackBar } from '@angular/material';
import { ConditionalErrorsModalService } from '../shared-components/conditional-errors-modal/conditional-errors-modal.service';
import { CommonHelper } from '../../../app/utilities/common.helper';
import { PopupService } from '../shared-components/modal/popup/popup.service';

@Injectable({
	providedIn: 'root'
})
export class SharedService {

	constructor(private http: HttpClient,
		private confirmationModalService: ConfirmationModalService,
		public _snackBar: MatSnackBar,
		private conditionalErrorModalService: ConditionalErrorsModalService, private popupModelService: PopupService) { }

	public getCountryList(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCountryList')
	}

	public getUniversityByCountry(countryId): Observable<any> {
		return this.http.get(environment.BASE_URL_LGSP + 'cmn/getUniversityByCountry/' + countryId)
	}

	public getCountryListbyScholarship(id): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'hsp/getCountryByScholarship/' + id)
	}

	public getLOACountryListbyScholarship(id): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'loa/getCountryByScholarship/' + id)
	}

	public getAddressDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + '/profile/getAddresses')
	}

	public getProvincesByCountryId(id): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getProvinces/' + id)
	}

	public getCountriesDialingCode(): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCountryDialingCodes')
	}

	public postSendMobileVerificationCode(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/sendCode', payload)
	}

	public postSendEmailVerificationCode(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/sendCode', payload)
	}

	public postVerificationCode(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/verifyCode', payload)
	}

	public login(payload, userLoginDetails): Observable<any> {
		let headers = new HttpHeaders();
		headers = headers.append('Authorization', 'Basic ' + btoa(payload.username + ":" + payload.password));
		headers = headers.append("X-Requested-With", "XMLHttpRequest");
		let httpOptions = { headers: headers, cache: false };
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/login', userLoginDetails, httpOptions);
	}

	public authenticate(payload): Observable<any> {
		const response: any = this.http.post<any>(
			environment.BASE_URL_AUTHENTICATE + "cmn/authenticate",
			payload
		);
		return response;
	}

	public getCitiesByCountryId(countryId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCities/' + countryId)
	}

	public logoutUser() {
		return this.http.get(environment.BASE_URL_PROFILE + 'auth/logout')
	}

	public getUserProfilePicture(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + 'profile/getProfilePicture')
	}

	public postUpdateProfilePicture(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + "profile/uploadImage", payload)
	}

	public getPersonalDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + "profile/getPersonalDetails")
	}
	public getPersonalDetailsAdmin(id): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + "puca/getApplicantDetails/" + id)
	}

	public updatePrimaryCellNumber(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/updatePrimaryContact', payload)
	}

	public updatePrimaryEmail(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/updatePrimaryEmail', payload)
	}

	public verifyOldPassword(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/verifyOldPassword', payload)
	}

	public verifyChangePasswordCode(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/verifyChangePasswordCode', payload)
	}

	public updatePassword(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'auth/updatePassword', payload)
	}

	public getCountryByDialingCode(countryId, countryDialingCode): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getCountryByDialingCodeAndCountryCode/' + countryId + '/' + countryDialingCode)
	}


	public getDistrictsByCityId(cityId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getDistrictByCityId/' + cityId)
	}

	public getPostalCodeByCityId(cityId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'cmn/getPostalCodeByCityId/' + cityId)
	}

	public saveAddress(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/saveAddress', payload)
	}

	public getCourseDetails(id): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + "irsip/getCourses/" + id)
		//return this.http.get("http://192.168.128.154:85/hec-profile-rest/rest/education/getEducationDetails")
	}

	public getEducationDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + "cpEducation/getEducationDetails")
		//return this.http.get("http://192.168.128.154:85/hec-profile-rest/rest/education/getEducationDetails")
	}

	public saveOrUpdateEducation(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'cpEducation/updateEducationDetails', payload)
	}

	public getApplicationData(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'puca/getPucaApplicationByAppId/' + appId)
	}

	public getProfileFormData(): Observable<any> {
		return this.http.get(environment.BASE_URL_PUCA + 'das/getInitFormData')
	}

	public addNotification(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/addNewNotification', payload)
	}

	public getAllNotifications(page): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + 'profile/getAllNotifications/' + page)
	}

	public getAllNotificationsByAcronyms(page, data): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/getAllNotificationsByAcronyms/' + page, data)
	}

	public getUnReadNotifications(data): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/getUnReadNotifications', data)
	}

	public updateNotification(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/updateNotification', payload)
	}

	public showPdf(formName, base64) {
		const linkSource = 'data:application/pdf;base64,' + base64;
		const downloadLink = document.createElement("a");
		const fileName = formName + ".pdf";

		downloadLink.href = linkSource;
		downloadLink.download = fileName;
		downloadLink.click();
	}

	public dateConverter(d) {
		let date: any;
		let month: any;
		if (d.getDate().toString().length < 2) {
			date = '0' + d.getDate().toString()
		} else {
			date = d.getDate().toString()
		}
		if ((d.getMonth() + 1).toString().length < 2) {
			month = '0' + (d.getMonth() + 1).toString()
		} else {
			month = (d.getMonth() + 1).toString()
		}
		const day = d.getFullYear().toString() + "-" + month + "-" + date;
		return day
	}

	public getDate(date): any {
		date = new Date(date)
		let month: any;
		let dated: any;
		if (date.getDate().toString().length < 2) {
			dated = '0' + date.getDate().toString()
		} else {
			dated = date.getDate().toString()
		}
		if ((date.getMonth() + 1).toString().length < 2) {
			month = '0' + (date.getMonth() + 1).toString()
		} else {
			month = (date.getMonth() + 1).toString()
		}
		let convertedDate = date.getFullYear() + "-" + month + "-" + dated;
		return convertedDate
	}

	checkAdminRole(roleList: any[]): boolean {
		return roleList.some(role => {
			return (role[1] == HEC_CONSTANTS.UserRoles.ASSISTANT || role[1] == HEC_CONSTANTS.UserRoles.FINANCE
				|| role[1] == HEC_CONSTANTS.UserRoles.AD || role[1] == HEC_CONSTANTS.UserRoles.DD
				|| role[1] == HEC_CONSTANTS.UserRoles.DIR || role[1] == HEC_CONSTANTS.UserRoles.ED)
		});
	}

	public getEmploymentDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + "profile/getEmploymentListData")
	}

	public saveOrUpdateEmployment(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'profile/saveEmploymentDetails', payload)
	}

	public saveOrUpdatePublication(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD + 'fdp/savePublications', payload);
	}

	public getEmploymentInfoDetails(): Observable<any> {
		return this.http.get(environment.BASE_URL_PROFILE + 'profile/getProfileFormData');
	}

	public getPublicationDetails(id:any): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD + 'fdp/getPublications/'+id);
	}

	public openCancelConfirmationDialog(title?, msg?, previewReport?) {
		return this.confirmationModalService
			.confirm(
				title || 'Please confirm',
				msg || 'Do you really want to reset form?',
				previewReport || false
			)
			.then((confirmed) => {
				return confirmed;
			})
			.catch((e) => { });
	}

	public showError(message, action, styleType) {
		this._snackBar.open(message, '', {
			duration: 3500,
			panelClass: [styleType],
		});
	}

	public openConditionalErrors(title?, msg?) {
		return this.conditionalErrorModalService
			.confirm(title || 'Title', msg || ['Message'])
			.then((res) => {
				// window.scroll(0, 0);
			})
			.catch((err) => {
				// window.scroll(0, 0);
			});
	}

	downloadPdf(payload, formName): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'cmn/reportGeneration/HRD/PUCA_ApplicationForm/pdf', payload);
	}
	downloadLOAPdf(payload, formName): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'cmn/reportGeneration/HRD/LOA_APPLICATION/pdf', payload);
	}
	downloadPdfIRSIP(payload, formName): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'cmn/reportGeneration/HRD/IRSIP_ApplicationForm/pdf', payload);
	}
	downloadBFAPIIPdf(payload, formName): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'cmn/reportGeneration/HRD/BFAP_APPLICATION_FORM/pdf', payload);
	}
	postComments(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_HRD_PUCA + 'puca/updateApplicationStatus/', payload);
	}

	downloadPdfPBSP(payload): Observable<any> {
		return this.http.get(
		  `${environment.BASE_URL_LGSP}reports/PBSP/PBSP_APPLICATION_FORM/${payload.APPLICATION_ID}`,
		  { responseType: 'blob' }
		);
	  }

	getDasComments(appId): Observable<any> {
		return this.http.get(environment.BASE_URL_HRD_PUCA + 'puca/getCommentsList/' + appId)
	}

	checkEligibility = (profileId, acronym): Observable<any> => {
		if (acronym == 'IRSIP')
			return this.http.get(`${environment.BASE_URL_HRD_PUCA}irsip/checkEligibility/${profileId}`);
		else if (acronym == 'PSP')
			return this.http.get(`${environment.BASE_URL_HRD_PUCA}psp/checkEligibility/${profileId}`);
		else
			return this.http.get(`${environment.BASE_URL_HRD_PUCA}puca/checkEligibility/${profileId}`);
	}

	irsipUploadDocument(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'doc/uploadDocument/', payload);
	}
	irsipDeleteDocument(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'doc/deleteDocument/', payload);
	}
	public uploadDocument(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_PROFILE + 'doc/uploadDocument/', payload)
	}
	public deleteDocument(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'attachment/deleteByDocumentId', payload)
	}

	public getAttachmentByDocumentId(payload) {
		return this.http.post(environment.BASE_URL_COMMON + 'attachment/getAttachmentByDocumentId', payload)
	}

	public saveDocumentDetails(payload): Observable<any> {
		return this.http.post(environment.BASE_URL_COMMON + 'attachment/uploadDocument', payload)
	}

	public getDocumentList(processAcronym, applicationId): Observable<any> {
		const payload = {
			data: {
				'applicationId': applicationId,
				'processAcronym': processAcronym
			}
		}
		return this.http.post(environment.BASE_URL_COMMON + 'attachment/getDocumentByAppIdAndAcronym', payload);
	}

	public markFormsTouched(form): void {
		CommonHelper.markFormGroupTouched(form);
	}

	public validate(f): boolean {
		if (f.status === 'VALID') {
			return true;
		}
	}

	public openPopupDialog(title?, msg?, popupType?) {
		return this.popupModelService
			.confirm(
				title || 'Please confirm',
				msg || 'Do you really want to reset form?',
				popupType || 'error'
			)
			.then((confirmed) => {
				return confirmed;
			})
			.catch((e) => { });


	}

	public getUniversityListByCountryId(countryId): Observable<any> {
		return this.http.get(environment.BASE_URL_COMMON + 'education/getUniversityListByCountryId/' + countryId)
	}

	public getUniversityListByCountryIdLgsp(countryId): Observable<any> {
		return this.http.get(environment.BASE_URL_LGSP + 'cmn/getUniversityListByCountryId/' + countryId)
	}
}
